var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contact-template__map-container" }, [
      _c("div", { staticClass: "contact-template__map", attrs: { id: "map" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78ac20ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/fabianschneider/Documents/Development/code/wordpress/lineabertoli/web/app/themes/lineabertoli/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ac20ac","hasScoped":false,"buble":{"transforms":{}}}!/Users/fabianschneider/Documents/Development/code/wordpress/lineabertoli/web/app/themes/lineabertoli/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/map-box.vue
// module id = 34
// module chunks = 0